export const TARGET_TYPE_PURCHASE = 1;
export const TARGET_TYPE_INVOICE = 2;
export const TARGET_TYPE_LEAD = 3;
export type CommentTargetTypes = 1 | 2 | 3;

export enum CommentType {
  USER = 'user',
  CONTACT = 'contact',
  SYSTEM = 'system',
}
